import { useEffect } from 'react'

import { useTranslation } from 'i18nano'
import { create } from 'zustand'

import type { TranslationFunction } from './useTranslate'

type TranslationStore = {
	t: TranslationFunction<undefined>
	setTranslationFunction: (func: TranslationFunction<undefined>) => void
}

const useTranslationStore = create<TranslationStore>((set) => ({
	t: () => '',
	setTranslationFunction: (func) => set({ t: func }),
}))

export const getTranslationFunction = () => useTranslationStore.getState().t
export const translate: TranslationFunction<undefined> = (path, values) =>
	getTranslationFunction()(path, values)

export const useTranslateInitializer = (): void => {
	const translation = useTranslation()
	const setTranslationFunction = useTranslationStore(
		(store) => store.setTranslationFunction
	)
	useEffect(() => {
		setTranslationFunction(translation)
	}, [translation, setTranslationFunction])
}
